"use client";

import { Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { create } from "zustand";

interface PortfolioState {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const usePortfolioStore = create<PortfolioState>((set) => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => set({ isOpen }),
}));

export function MobilePortfolioToggle() {
  const { setIsOpen } = usePortfolioStore();

  return (
    <Button
      onClick={() => setIsOpen(true)}
      className="w-10 h-10 rounded-full bg-[#f9cd4f] border border-[#d4a012] hover:bg-[#e8bc3a] shadow-lg p-0 flex items-center justify-center"
    >
      <Wallet className="h-5 w-5 text-[#111]" />
    </Button>
  );
}
